import { Injectable } from '@angular/core';
import { FeatureFlag } from '@app/enums';
import { MenuService } from '@app/services/menu/menu.service';

@Injectable()
export class RolePermissionsMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = [
            {
                key: 'settings.role-permissions.levels.personal',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'personal' },
            },
            {
                key: 'settings.role-permissions.levels.jobAndPay',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'job-and-pay' },
            },
            {
                key: 'settings.role-permissions.levels.reminders',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'reminders' },
            },
            {
                key: 'settings.role-permissions.levels.records',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'records' },
            },
            {
                key: 'settings.role-permissions.levels.journey',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'journey' },
            },
            {
                key: 'settings.role-permissions.levels.benefits',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'benefits' },
            },
            {
                key: 'settings.role-permissions.levels.performance',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'performance' },
            },
            {
                key: 'settings.role-permissions.levels.survey',
                link: ['/settings', 'roles', ':role', 'permissions'],
                queryParams: { tab: 'survey' },
                showIfHasFeatureFlag: FeatureFlag.performanceModuleSplit,
            },
        ];
    }
}
